import React from 'react'

const Redeem = () => {
  return (
    <div>

        <div className='container mt-5 h-100 mt-5 pt-5'>
            <div className='row'>
                <div className='col-lg-12 col-sm-12'>
                    <div>
                        <p>Redeem your refer balance </p>
                        <p style={{fontSize:'14px'}}>TDS (0%) will be deducted after annual referral earning of ₹15,000. </p>

                        <span  style={{fontSize:'12px'}}>Enter Amount (Min: 190, Max: 10000)</span>
                    </div>


                    <div class="mb-3 mt-4">
    <label for="exampleInputEmail1" class="form-label"> </label>
    <input type="number" class="form-control py-2" id="exampleInputEmail1" aria-describedby="emailHelp"  placeholder='Enter Amount'  style={{boxShadow:'none', border:'1px solid #ffcc5b'}}/> 
    <div style={{color:'#ffab00', fontSize:'14px'}}>Minimum withdrawal amount ₹190    </div>
  </div>
  <h6 style={{}}>Money will be added to cash.</h6>

  <button className='btn btn-primary mt-5'>Redeem</button>

                </div>
            </div>
        </div>
    </div>
  )
}

export default Redeem